import { render, staticRenderFns } from "./NewTruckTemplate.vue?vue&type=template&id=e26bad44"
import script from "./NewTruckTemplate.vue?vue&type=script&lang=ts"
export * from "./NewTruckTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports